import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { Input } from '@/components/Input';
import { PasswordField } from '@/components/PasswordField';
import { Text } from '@/components/Text';
import { register } from '@/resource/account';
import { LocationItemType } from '@/resource/location';
import { SetState } from '@/util/types';
import { useState } from 'react';
import { Link } from '../Link';

type Props = {
  isActive: boolean;
  hasSoftKeyboard: boolean;
  isValid: boolean;
  firstName: string;
  lastName: string;
  postalCode: string;
  email: string;
  setEmail: SetState<string>;
  setPassword: SetState<string>;
  setPasswordOk: SetState<boolean>;
  password: string;
  phone: string;
  allowContact: boolean;
  location: LocationItemType;
  onBack: () => void;
  onNext: () => void;
};

export function Step3({
  isValid,
  hasSoftKeyboard,
  isActive,
  firstName,
  lastName,
  postalCode,
  password,
  phone,
  allowContact,
  location,
  email,
  setEmail,
  setPassword,
  setPasswordOk,
  onBack,
  onNext,
}: Props) {
  const [error, setError] = useState<
    | 'unknown'
    | 'profile_exists'
    | 'location_not_found'
    | 'could_not_create_profile'
    | undefined
  >(undefined);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();

        register({
          firstName,
          lastName,
          email,
          password,
          phone,
          postalCode,
          locationId: location?.id || 0,
          allowContact,
        }).then((res) => {
          if (res.type === 'ok') {
            onNext();
          } else if (res.type === 'catch') {
            setError(res.data.reason);
          }
        });
      }}
    >
      <Flex dir="column" gap={4}>
        <Heading align="center">Inlog gegevens</Heading>

        <Input
          label="E-mailadres"
          type="email"
          id="email"
          value={email}
          minLength={3}
          maxLength={128}
          required
          autoComplete="email"
          autoFocus={isActive && !hasSoftKeyboard}
          onChange={(e) => setEmail(e.target.value)}
        />

        <PasswordField
          disabled={!isActive}
          email={email}
          firstName={firstName}
          lastName={lastName}
          postalCode={postalCode}
          onChange={({ ok, password }) => {
            setPassword(password);
            setPasswordOk(ok);
          }}
        />

        {error === 'profile_exists' && (
          <Text align="center" balance>
            Er bestaat al een account met dit e-mailadres.{' '}
            <Link to={{ type: 'forgot_password' }} underline>
              Stel je wachtwoord opnieuw in
            </Link>
            .
          </Text>
        )}

        <Flex justify="space-between">
          <Button
            theme="secondary"
            onClick={onBack}
            icon="chevron_left_narrow"
            iconSize={2}
          >
            Contact gegevens
          </Button>
          <Button
            type="submit"
            disabled={!isValid}
            icon="chevron_right_narrow"
            iconSize={2}
            iconPosition="right"
          >
            Stuur code
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
}
